<template lang="pug">
div(class='yotpo yotpo-shoppers-say' :data-product-id='yotpoId')
</template>

<script setup lang="ts">
useYotpo()
const { yotpoId } = defineProps<{ yotpoId: string }>()
</script>

<style lang="stylus">
.yotpo-shoppers-say .single-best-sentence .more-reviews
    display none

@screen lg
    .yotpo-shoppers-say .single-best-sentence .more-reviews
        display block
</style>
